import * as React from 'react';
export const ListContext = React.createContext({
    iconSize: 'xs',
});
export default class List extends React.Component {
    BEM() {
        const classArray = ['list'];
        if (this.props.type) {
            classArray.push('list--' + this.props.type);
        }
        if (this.props.type === 'icon') {
            classArray.push('list--icon-position-' + this.props.iconPosition);
        }
        if (this.props.size) {
            classArray.push('list--' + this.props.size);
        }
        if (this.props.direction) {
            classArray.push('list--direction-' + this.props.direction);
        }
        if (this.props.bordered) {
            classArray.push('list--bordered');
            if (this.props.outerBordered) {
                classArray.push('list--outer-bordered');
            }
        }
        if (this.props.fullWidth) {
            classArray.push('list--full-width');
        }
        if (this.props.noGutter) {
            if (this.props.noGutter === 'all') {
                classArray.push('list--no-gutter');
            }
            else {
                classArray.push(`list--no-${this.props.noGutter}-gutter`);
            }
        }
        if (this.props.className) {
            classArray.push(this.props.className);
        }
        if (this.props.spacing) {
            classArray.push('list--spacing-' + this.props.spacing);
        }
        return classArray.join(' ');
    }
    render() {
        const ListElement = this.props.type === 'ordered' ? 'ol' : 'ul';
        const listContextValue = {
            icon: this.props.icon,
            iconSize: this.props.size === 'xsmall' ? 'xxs' : this.props.size === 'large' ? 'sm' : 'xs',
            iconClassName: this.props.iconClassName,
        };
        return (React.createElement(ListContext.Provider, { value: listContextValue },
            React.createElement("div", { className: this.BEM() },
                React.createElement(ListElement, { className: "list__inner" }, this.props.children))));
    }
}
List.defaultProps = {
    outerBordered: true,
    iconPosition: 'top',
    size: 'small',
};
